import styled from "styled-components"
import { transparentize } from "polished"
import Button from "../../components/button"
import SearchBox from "../../components/search-box"

export const AdjustedSearchBox = styled(SearchBox)`
  line-height: 1;
  color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};

  &::placeholder {
    color: ${({ theme }) => transparentize(0.6, theme.colors.secondaryAlternative || theme.colors.secondary)};
  }
`
export const LoadMoreButton = styled(Button)`
  padding: 0.75rem 2rem;
  font-size: 1.25rem;
`
